export const developersTranslations = {
  es: {
    'seo-title': 'Portal de Desarrolladores | BlueCMR API',
    'seo-description': 'Integra BlueCMR en tus sistemas con nuestra API REST. Crea documentos de transporte, gestiona firmas electrónicas y automatiza flujos desde tu TMS o ERP.',
    'breadcrumb': 'Desarrolladores',
    'badge': 'Developer Portal',
    'title': 'Portal de Desarrolladores',
    'subtitle': 'Conecta tu TMS, ERP o sistema de flotas con BlueCMR mediante nuestra API REST. Automatiza la creación de documentos, el envío de firmas y la consulta de estados.',
    'cta-login': 'Acceder al portal',

    'features-title': 'Qué puedes hacer con la API',
    'features-subtitle': 'Integra la gestión documental de transporte directamente en tus sistemas',

    'cap-api': 'API REST de documentos',
    'cap-api-desc': 'Crea, consulta, modifica y activa documentos de transporte con validación eFTI automática.',
    'cap-signature': 'Envío de firmas',
    'cap-signature-desc': 'Envía documentos para firma electrónica por email o SMS, individual o en lote.',
    'cap-links': 'Enlaces embebibles',
    'cap-links-desc': 'Integra la firma y visualización de documentos en tu app móvil o portal de clientes.',
    'cap-webhooks': 'Webhooks',
    'cap-webhooks-desc': 'Recibe notificaciones automáticas cuando un documento cambia de estado o se firma.',
    'cap-security': 'Autenticación JWT',
    'cap-security-desc': 'Control de acceso por cuenta con aislamiento de datos y roles por documento.',
    'cap-models': 'Modelos personalizados',
    'cap-models-desc': 'eCMR, DCA, Carta de Porte y plantillas propias con campos configurables.',

    'cta-title': '¿Necesitas ayuda con la integración?',
    'cta-subtitle': 'Nuestro equipo técnico puede guiarte en el proceso de conexión con tus sistemas.',
    'cta-access': 'Acceder al portal',
    'cta-contact': 'Contactar equipo técnico',
  },
  en: {
    'seo-title': 'Developer Portal | BlueCMR API',
    'seo-description': 'Integrate BlueCMR into your systems with our REST API. Create transport documents, manage electronic signatures and automate workflows from your TMS or ERP.',
    'breadcrumb': 'Developers',
    'badge': 'Developer Portal',
    'title': 'Developer Portal',
    'subtitle': 'Connect your TMS, ERP or fleet system with BlueCMR through our REST API. Automate document creation, signature sending and status queries.',
    'cta-login': 'Access the portal',

    'features-title': 'What you can do with the API',
    'features-subtitle': 'Integrate transport document management directly into your systems',

    'cap-api': 'Document REST API',
    'cap-api-desc': 'Create, query, modify and activate transport documents with automatic eFTI validation.',
    'cap-signature': 'Signature sending',
    'cap-signature-desc': 'Send documents for electronic signature via email or SMS, individually or in batch.',
    'cap-links': 'Embeddable links',
    'cap-links-desc': 'Integrate document signing and viewing into your mobile app or client portal.',
    'cap-webhooks': 'Webhooks',
    'cap-webhooks-desc': 'Receive automatic notifications when a document changes status or is signed.',
    'cap-security': 'JWT Authentication',
    'cap-security-desc': 'Account-level access control with data isolation and per-document roles.',
    'cap-models': 'Custom models',
    'cap-models-desc': 'eCMR, DCA, Waybill and custom templates with configurable fields.',

    'cta-title': 'Need help with integration?',
    'cta-subtitle': 'Our technical team can guide you through the process of connecting with your systems.',
    'cta-access': 'Access the portal',
    'cta-contact': 'Contact technical team',
  },
};
